module.exports = {"version":2,"waiters":{"FunctionExists":{"delay":1,"operation":"GetFunction","maxAttempts":20,"acceptors":[{"state":"success","matcher":"status","expected":200},{"state":"retry","matcher":"error","expected":"ResourceNotFoundException"}]}}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-sdk/apis/lambda-2015-03-31.waiters2.json
// module id = 1964
// module chunks = 0